<ng-container *transloco="let t; prefix: 'job-insights-cta'">
  <div class="job-insights-cta widget" [class.highlight]="!config().comingSoon">
    <img alt="" src="assets/images/icons/insights.svg" />

    <div class="wrapper">
      <div class="header">
        <div class="header-content">
          <div class="title">
            <h2>{{ t('title') }}</h2>

            @if (config().comingSoon) {
              <accredible-chip [data]="t('coming-soon')" />
            }
          </div>

          <img alt="" src="assets/images/icons/insights.svg" />
        </div>

        <div class="description">
          {{ config().description }}
        </div>
      </div>

      <div>
        <a
          class="cta-button"
          mat-stroked-button
          color="primary"
          target="_blank"
          [href]="ctaButtonLink()"
          data-cy="btn-join-waiting-list">
          <span>{{ config().linkLabel }}</span>
          <accredible-icon [icon]="'external'" />
        </a>
      </div>
    </div>
  </div>
</ng-container>
